import React from 'react';
import { Navigate, Route } from 'react-router-dom';

// Import PDF components
import ProtectedRoute from '../components/auth/ProtectedRoute';
import PDFCreator from '../pages/PDFCreator';
import PDFEditor from '../components/pdf/PDFEditor';
import PDFAnalytics from '../components/pdf/PDFAnalytics';
import PDFShare from '../components/pdf/PDFShare';
import PDFPublicView from '../pages/PDFPublicView';
import PDFCategories from '../components/pdf/PDFCategories';

const pdfRoutes = [
  // PDF list/creator page
  <Route 
    path="pdf" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'pdfs', action: 'read' }}>
        <PDFCreator />
      </ProtectedRoute>
    } 
  />,
  
  // PDF create page
  <Route
    path="pdf/create"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'pdfs', action: 'create' }}>
        <PDFEditor isNew />
      </ProtectedRoute>
    }
  />,
  
  // PDF edit page
  <Route
    path="pdf/edit/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'pdfs', action: 'update' }}>
        <PDFEditor />
      </ProtectedRoute>
    }
  />,
  
  // PDF analytics page
  <Route
    path="pdf/analytics/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'pdfs', action: 'view_analytics' }}>
        <PDFAnalytics />
      </ProtectedRoute>
    }
  />,
  
  // PDF share page
  <Route
    path="pdf/share/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'pdfs', action: 'share' }}>
        <PDFShare />
      </ProtectedRoute>
    }
  />,
  
  // PDF categories page
  <Route
    path="pdf/categories"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'pdfs', action: 'manage_categories' }}>
        <PDFCategories />
      </ProtectedRoute>
    }
  />,
  
  // Public PDF view routes (no auth required)
  <Route path="pdf/view/:id" element={<PDFPublicView />} />,
  <Route path="p/:shortCode" element={<PDFPublicView />} />,
  <Route path="docs/:slug" element={<PDFPublicView />} />,
  
  // Redirect /pdf/* to /pdf if no match
  <Route path="pdf/*" element={<Navigate to="/pdf" replace />} />
];

export default pdfRoutes;